import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.keys');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-keys',
template: templateSource || '',
    styles: [``],
})
export class PageKieraKeysComponent implements OnInit {
    public list: any[] = [];
    public search: any = { text: '' };
    public showAddModal: boolean = false;
    public showUploadModal: boolean = false;
    public newKey: any = { name: '', password: '' };
    public uploadKey: any = { name: '', password: '', private_key: null, public_key: null };
    public uploading = false;
    public uploadError = '';
    public revealed: { [key: string]: string } = {};

    // Sorting
    public sortField: string = 'name';
    public sortDir: string = 'asc';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("search", this.search);
        if (code === 200) {
            this.list = data.rows || [];
            this.revealed = {};
            this.sortList();
        }
        await this.service.render();
    }

    public async addKey() {
        if (!this.newKey.name) return;
        const { code } = await wiz.call("create", { data: JSON.stringify(this.newKey) });
        if (code === 200) {
            this.showAddModal = false;
            this.newKey = { name: '', password: '' };
            await this.load();
        }
    }

    public async readKeyFile(event: Event, type: 'private_key' | 'public_key') {
        this.uploadError = '';
        const file = (event.target as HTMLInputElement).files?.[0];
        this.uploadKey[type] = null;
        if (file) {
            if (file.size > 65536) this.uploadError = await this.service.lang.translate('gap.keys.size');
            else this.uploadKey[type] = await file.text();
        }
        await this.service.render();
    }

    public async uploadKeyPair() {
        if (this.uploading || !this.uploadKey.name.trim() || !this.uploadKey.private_key) return;
        this.uploading = true;
        this.uploadError = '';
        await this.service.render();
        try {
            const res = await wiz.call('create', { data: JSON.stringify(this.uploadKey) });
            if (res.code !== 200) {
                this.uploadError = res.message || await this.service.lang.translate('gap.keys.failed');
                return;
            }
            this.showUploadModal = false;
            this.uploadKey = { name: '', password: '', private_key: null, public_key: null };
            await this.load();
        } catch (_) { this.uploadError = await this.service.lang.translate('gap.keys.failed');
        } finally { this.uploading = false; await this.service.render(); }
    }

    public closeUpload() {
        if (this.uploading) return;
        this.showUploadModal = false;
        this.uploadKey = { name: '', password: '', private_key: null, public_key: null };
        this.uploadError = '';
    }

    public async deleteKey(id: number) {
        if (!confirm("Are you sure you want to delete this key pair?")) return;
        const { code } = await wiz.call("delete", { id });
        if (code === 200) await this.load();
    }

    public revealKey(item: any, keyType: 'public' | 'private') {
        return this.toggleKey(item, keyType);
    }

    private async toggleKey(item: any, keyType: 'public' | 'private') {
        const cacheKey = `${item.id}:${keyType}`;
        if (this.revealed[cacheKey]) {
            delete this.revealed[cacheKey];
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("reveal", { id: item.id, type: keyType });
        if (code === 200 && data?.value) {
            this.revealed[cacheKey] = data.value;
        }
        await this.service.render();
    }

    public keyValue(item: any, keyType: 'public' | 'private'): string {
        return this.revealed[`${item.id}:${keyType}`] || '••••••••••••';
    }

    public isKeyVisible(item: any, keyType: 'public' | 'private'): boolean {
        return !!this.revealed[`${item.id}:${keyType}`];
    }

    // ===== Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (field === 'id') return (Number(va) - Number(vb)) * dir;
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }
}

export default PageKieraKeysComponent;
